import { useEffect } from "react";
import { useQuery } from "react-query";
import { PaymentService } from "../../services/PaymentService";
import { useAppSelector } from "../../store/Hooks";
import { Select } from "antd";
import { t } from "i18next";

export type PayableHotelSelectProps = {
    onChange?: Function;
}

export const PayableHotelSelect = (props: PayableHotelSelectProps) => {
    const siteStore = useAppSelector((store) => store.site);

    useEffect(() => {
        if (!data) {
            refetch();
        }
    }, [props]);

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getPayableHotelList"],
        () => (PaymentService.GetPayableHotelList({})),
        {
            refetchOnWindowFocus: false,
            enabled: false,
            cacheTime: 0
        }
    )

    return (
        <>
            <Select
                loading={isLoading}
                onChange={(value: string) => props.onChange && props.onChange(value)}
                showSearch
                placeholder={t("common.chooseHotel")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.localName,
                    value: h.id
                }))}
            >
            </Select>
        </>
    )
}